// Organizasyon teklifi PDF'inin son sayfası — rezervasyon, ödeme ve iptal koşulları.
//
// Metin Ayarlar > Organizasyon'dan düzenlenir (settings kategorisi 'events' → termsText).
// Kayıtlı metin yoksa aşağıdaki ÖRNEK metin kullanılır — proje sahibi işletmesine göre düzenlemelidir.
//
// Basit yazım kuralları (Ayarlar ekranında da anlatılır):
//   # Başlık        → sayfa başlığı (ilk satır; yoksa varsayılan başlık)
//   ## Bölüm        → bölüm başlığı
//   - madde         → madde işaretli satır
//   diğer satırlar  → paragraf (boş satır paragrafları ayırır)

export const DEFAULT_EVENT_TERMS_TITLE = 'ORGANİZASYON REZERVASYON VE İPTAL KOŞULLARI';

export const DEFAULT_EVENT_TERMS = `# ORGANİZASYON REZERVASYON VE İPTAL KOŞULLARI

## Rezervasyon ve Ödeme
- Organizasyon tarihi ve salon, teklifte belirtilen kapora tutarının ödenmesiyle kesinleşir. Kapora ödenmeden tarih ve salon garanti edilmez.
- Kalan tutar, teklifte belirtilen son ödeme tarihine kadar eksiksiz ödenmelidir.
- Teklif, üzerinde belirtilen geçerlilik tarihine kadar geçerlidir; bu tarihten sonra fiyat ve müsaitlik yeniden değerlendirilir.

## Katılımcı Sayısı
- Kesin katılımcı sayısı organizasyondan en geç 7 gün önce yazılı olarak bildirilmelidir. Ücretlendirme, bildirilen kesin sayı ile gerçekleşen sayıdan yüksek olanı üzerinden yapılır.
- Bildirilen sayının üzerindeki katılımcılar için kişi başı ücretler ayrıca tahsil edilir.

## İptal ve Değişiklik
- Organizasyon tarihine 30 günden fazla süre kala yapılan iptallerde ödenen kapora iade edilmez; ayrıca ücret talep edilmez.
- Organizasyon tarihine 30–15 gün kala yapılan iptallerde toplam bedelin %50'si tahsil edilir.
- Organizasyon tarihine 14 gün veya daha az süre kala yapılan iptallerde toplam bedelin %100'ü tahsil edilir.
- Tarih değişikliği talepleri müsaitliğe bağlıdır ve en geç 30 gün önce yazılı olarak iletilmelidir.
- İptal ve değişiklik talepleri yazılı olarak iletilmelidir; talebin otel tarafından alındığı tarih esas alınır.

## Genel Koşullar
- Dışarıdan yiyecek ve içecek getirilemez; pasta vb. istisnalar önceden yazılı onaya tabidir.
- Organizasyon, teklifte belirtilen saatler içinde gerçekleştirilir; süre aşımında ek ücret uygulanabilir.
- Dekorasyon, ses-ışık ve dış tedarikçi kurulumları otel yönetiminin onayıyla yapılır.
- Organizasyon süresince katılımcıların otel tesislerine ve ekipmanına verdiği hasarlardan organizasyon sahibi sorumludur.
- Mücbir sebep veya ilgili mevzuattan doğan zorunlu haller saklıdır.`;

// Metni PDF bloklarına çevirir: { title, blocks: [{ type: 'heading' | 'bullet' | 'paragraph', text }] }
export const parseTermsText = (text) => {
  const source = typeof text === 'string' && text.trim() ? text : DEFAULT_EVENT_TERMS;
  let title = '';
  const blocks = [];
  let paragraph = [];
  const flush = () => {
    if (paragraph.length) blocks.push({ type: 'paragraph', text: paragraph.join(' ') });
    paragraph = [];
  };
  source.replace(/\r\n/g, '\n').split('\n').forEach((raw) => {
    const line = raw.trim();
    if (!line) { flush(); return; }
    if (/^#\s+/.test(line) && !/^##/.test(line)) {
      flush();
      if (!title && blocks.length === 0) title = line.replace(/^#\s+/, '').trim();
      else blocks.push({ type: 'heading', text: line.replace(/^#\s+/, '').trim() });
      return;
    }
    if (/^##+\s*/.test(line)) { flush(); blocks.push({ type: 'heading', text: line.replace(/^##+\s*/, '').trim() }); return; }
    if (/^[-•*]\s+/.test(line)) { flush(); blocks.push({ type: 'bullet', text: line.replace(/^[-•*]\s+/, '').trim() }); return; }
    paragraph.push(line);
  });
  flush();
  return { title: title || DEFAULT_EVENT_TERMS_TITLE, blocks: blocks.filter(b => b.text) };
};

// Başlığı PDF'te iki satıra böler (oda teklifi başlığıyla aynı görünüm)
export const splitTitleLines = (title) => {
  const words = String(title || '').split(/\s+/).filter(Boolean);
  if (words.length < 4) return [words.join(' ')];
  const mid = Math.ceil(words.length / 2);
  return [words.slice(0, mid).join(' '), words.slice(mid).join(' ')];
};
